import pageStyle from "./index.module.less";
import * as service from "../../../service";

export default {
    name: "SelectTicketTagType",
    data() {
        return {
            options: [],
            pageStyle
        };
    },
    model: {
        prop: "value",
        event: "change"
    },
    props: {
        value: [Number, String]
    },
    created() {
        this.getSeletData();
    },
    methods: {
        async getSeletData() {
            const { list } = await service.listType(),
                options = [];

            list.forEach(value => {
                if (value.pid != 0) {
                    options.push({
                        ...value
                    });
                }
            });
            this.options = options;
        },

        onChange(value) {
            this.$emit("change", value);
        }
    }
};
